import { monthsArray } from ".";
import { Dropdown } from "../../components/Dropdown";


const getMonths = () => {

  return monthsArray.map((item, index) => ({ id: index, value: item }))
}

const years = [{
  id: 0,
  value: new Date().getFullYear()
},
{
  id: 0,
  value: new Date().getFullYear() - 1
}
]

export const formData: any = () => {
  return [
    {
      formItems: [
        {
          horizontalComps: [

            {
              fieldName: 'months',
              ComponentName: Dropdown,
              minWidth: 140,
              title: 'Month',
              label: 'Select Month',
              data: getMonths(),
            },
            {
              fieldName: 'year',
              ComponentName: Dropdown,
              minWidth: 140,
              title: 'Year',
              label: 'Select Year',
              data: years,
            }
          ],
        },
      ],
      horizontalFlex: 1,
      onSubmit: () => {
        return 'end'
      },
    },
  ]
}